import angular from 'angular';
import {WhatsappVia360DRegisterController} from './addAccountWhatsappVia360D.controller.js';

angular.module('parameters.addAccountWhatsappVia360DRegister', []).controller('WhatsappVia360DRegisterController', WhatsappVia360DRegisterController);
